import { observer } from 'mobx-react-lite'
import CurriculumCardShort from './components/CurriculumCardShort/CurriculumCardShort'
import useCurriculumSection from './hooks/useCurriculumSection'
import s from './styles/CurriculumSection.module.scss'

const CurriculumSection = observer(() => {
	const {
		cards,
		handleViewAllSessions,
		handleResourceClick,
		handleTaskClick,
		handleMarkComplete,
	} = useCurriculumSection()

	if (!cards.length) return null

	return (
		<section className={s.section}>
			<h2 className={s.title}>Curriculum</h2>

			<div className={s.grid}>
				{cards.map(card => (
					<CurriculumCardShort
						key={card.gradeId}
						card={card}
						onViewAllSessions={handleViewAllSessions}
						onResourceClick={handleResourceClick}
						onTaskClick={handleTaskClick}
						onMarkComplete={handleMarkComplete}
					/>
				))}
			</div>
		</section>
	)
})

export default CurriculumSection
